var EPS = 0.1;
module.exports = AFRAME.registerComponent('checkpoint-controls', {
  schema: {
    enabled: {
      default: true
    },
    mode: {
      default: 'teleport',
      oneOf: ['teleport', 'animate']
    },
    animateSpeed: {
      default: 3.0
    }
  },
  init: function init() {
    this.active = true;
    this.checkpoint = null;
    this.isNavMeshConstrained = false;
    this.offset = new THREE.Vector3();
    this.position = new THREE.Vector3();
    this.targetPosition = new THREE.Vector3();
  },
  play: function play() {
    this.active = true;
  },
  pause: function pause() {
    this.active = false;
  },
  setCheckpoint: function setCheckpoint(checkpoint) {
    var el = this.el;
    if (!this.active) return;
    if (this.checkpoint === checkpoint) return;
    if (this.checkpoint) {
      el.emit('navigation-end', {
        checkpoint: this.checkpoint
      });
    }
    this.checkpoint = checkpoint;
    this.sync();

    // Ignore new checkpoint if we're already there.
    if (this.position.distanceTo(this.targetPosition) < EPS) {
      this.checkpoint = null;
      return;
    }
    el.emit('navigation-start', {
      checkpoint: checkpoint
    });
    if (this.data.mode === 'teleport') {
      this.el.setAttribute('position', this.targetPosition);
      this.checkpoint = null;
      el.emit('navigation-end', {
        checkpoint: checkpoint
      });
      el.components['movement-controls'].updateNavLocation();
    }
  },
  isVelocityActive: function isVelocityActive() {
    return !!(this.active && this.checkpoint);
  },
  getVelocity: function getVelocity() {
    if (!this.active) return;
    var data = this.data;
    var offset = this.offset;
    var position = this.position;
    var targetPosition = this.targetPosition;
    var checkpoint = this.checkpoint;
    this.sync();
    if (position.distanceTo(targetPosition) < EPS) {
      this.checkpoint = null;
      this.el.emit('navigation-end', {
        checkpoint: checkpoint
      });
      return offset.set(0, 0, 0);
    }
    offset.setLength(data.animateSpeed);
    return offset;
  },
  sync: function sync() {
    var offset = this.offset;
    var position = this.position;
    var targetPosition = this.targetPosition;
    position.copy(this.el.getAttribute('position'));
    this.checkpoint.object3D.getWorldPosition(targetPosition);
    targetPosition.add(this.checkpoint.components.checkpoint.getOffset());
    offset.copy(targetPosition).sub(position);
  }
});